// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-list_root__Iay6y","fullHeight":"cart-list_fullHeight__24gHN","section":"cart-list_section__1ri6e","header":"cart-list_header__14X0h","title":"cart-list_title___XJQC"};